import { Icon } from '@ui-component-library';
import { ToolboxContainer } from '../../components/minskog/helpers';

/**
 * Map toolbox for auction details only: zoom + browser fullscreen (not shared with MapComponents / VBLeaflet).
 * Fullscreen state for styling comes from the parent (synced on fullscreenchange, like Karta.js).
 */
export default function AuctionDetailsMapControls({ mapRef, fullscreenTargetRef, isFullscreen }) {
    const toggleFullscreen = () => {
        const el = fullscreenTargetRef?.current;
        if (!el) return;
        const doc = document;
        if (!doc.fullscreenElement && !doc.webkitFullscreenElement) {
            const req = el.requestFullscreen || el.webkitRequestFullscreen;
            if (req) req.call(el);
        } else {
            const exit = doc.exitFullscreen || doc.webkitExitFullscreen;
            if (exit) exit.call(doc);
        }
    };

    return (
        <ToolboxContainer className="absolute z-[1000]" style={{ right: '5px' }}>
            <div className="flex flex-col bg-neutral-cloud shadow rounded p-1">
                <div
                    role="button"
                    onClick={() => mapRef.current?.zoomIn()}
                    className="flex justify-center items-center bg-white hover-bg-supp-forest-green-300 rounded mb-1"
                    style={{ height: '30px' }}
                >
                    <img src={`${Window.static_path}img/icons/plus.svg`} height="20px" width="20px" alt="" />
                </div>
                <div
                    role="button"
                    onClick={() => mapRef.current?.zoomOut()}
                    className="flex justify-center items-center bg-white hover-bg-supp-forest-green-300 rounded mb-1"
                    style={{ height: '30px' }}
                >
                    <img src={`${Window.static_path}img/icons/minus.svg`} height="30px" width="30px" alt="" />
                </div>
                <div
                    role="button"
                    title={isFullscreen ? 'Avsluta helskärm' : 'Helskärm'}
                    aria-label={isFullscreen ? 'Avsluta helskärm' : 'Helskärm'}
                    onClick={toggleFullscreen}
                    className={`flex justify-center items-center rounded ${
                        isFullscreen
                            ? 'bg-supp-forest-green-300 hover-bg-supp-forest-green-300'
                            : 'bg-white hover-bg-supp-forest-green-300'
                    }`}
                    style={{ height: '30px' }}
                >
                    {isFullscreen ? (
                        <Icon name="ArrowsIn" className="text-charcoal-500" size="large" />
                    ) : (
                        <Icon name="ArrowsOut" className="text-charcoal-500" size="large" />
                    )}
                </div>
            </div>
        </ToolboxContainer>
    );
}
